module.exports = __webpack_public_path__ + "static/waves-hero-c34908b15719532d7dd1cd72b7ee08d6.jpg";